/** @format */
import { css } from 'styled-components';

import { theme } from '@toucan/client/global/theme';

export const styles = css`
    margin-bottom: var(--layout-spacing-32);

    .extra-accessory__title {
        display: flex;
        gap: var(--layout-spacing-8);
        align-items: center;
        ${theme.typography.body_large}
        color: var(--colors-text-secondary);
        margin-bottom: var(--layout-spacing-8);
    }

    .extra-accessory__icon svg {
        fill: var(--colors-surface-accent-inverse);
    }
    .extra-accessory__icon--hidden {
        display: none;
    }

    .extra-accessory__description {
        ${theme.typography.body_small}
        margin-bottom: var(--layout-spacing-16);

        strong {
            color: var(--colors-text-secondary);
        }
    }

    .extra-accessory__options {
        display: flex;
        flex-wrap: wrap;
        gap: var(--layout-spacing-8);
        margin-bottom: var(--layout-spacing-8);
    }
`;
